if ( document.getElementById( 'category_selector' ) ) {
  const urlmenu = document.getElementById( 'category_selector' );
  urlmenu.onchange = function() {
    window.open( this.options[ this.selectedIndex ].value, '_self' );
  };
}
